// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__dxmcK","range":"MonthRangeSwitch_range__nLIGD","disabled":"MonthRangeSwitch_disabled__1dRin"};